import { IconGeoTag, Text } from '@direct-frontend/components';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- Нужно поправить
import { CourierAddressPicker, type CourierAddressPickerValue } from '@/features/CourierAddressPicker';
import { type OrderDto } from '@/shared/api/order';
import { Trigger, type TriggerProps } from '@/shared/components/Trigger';
import { reinitializeOrderForm } from '../../lib/reinitializeOrderForm';
import styles from './CourierAddressInput.module.css';

type CourierAddressInputProps = TriggerProps & {
    order: OrderDto;
    storeSlug: string;
    locality: string;
    value?: CourierAddressPickerValue;
    onChange?: (address: CourierAddressPickerValue) => void;
    openRegistrationOzon: VoidFunction;
};

export const CourierAddressInput = (props: CourierAddressInputProps) => {
    const { order, storeSlug, value, locality, onChange, openRegistrationOzon, ...other } = props;

    return (
        <CourierAddressPicker
            order={order}
            reinitializeOrderForm={reinitializeOrderForm}
            storeSlug={storeSlug}
            value={value}
            locality={locality}
            onChange={onChange}
        >
            {({ onOpenModal }) => (
                // если не добавить эту обёртку, то клик дойдёт до модалки и выставится фокус не в то поле
                <div
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                >
                    <Trigger
                        {...other}
                        className={styles.button}
                        iconLeft={<IconGeoTag size="24" />}
                        onClick={onOpenModal}
                    >
                        <Text size="mc">{value?.address ?? ' '}</Text>
                    </Trigger>
                </div>
            )}
        </CourierAddressPicker>
    );
};
